<template>
    <div class="d-flex align-items-center mb-2 search-deal-input">
        <div>
            <select
                class="form-control"
                title="Search by"
                v-model="search_by"
                @change="onSearchByChange"
            >
                <option :value="null">Search by</option>


                <option
                    :value="search_by_option.value"
                    v-for="search_by_option in search_by_options"
                >
                    {{ search_by_option.text }}
                </option>
            </select>
        </div>
        <form class="app-search m-0" role="search" v-if="search_by">
            <div class="form-group mb-0">
                <div v-if="current_search_by_type === SEARCH_BY_TYPES.text">
                    <input
                        class="form-control search-input"
                        type="search"
                        v-model="search_query"
                    >
                </div>
                <date-picker
                    valueType="YYYY-MM-DD"
                    class="search-datepicker"
                    type="date"
                    v-model="search_query"
                    v-if="current_search_by_type === SEARCH_BY_TYPES.date"
                />
                <button type="button">
                    <i class="mdi mdi-magnify"/>
                </button>
            </div>
        </form>
    </div>
</template>

<script>
    import _ from 'lodash';

    const SEARCH_BY_TYPES = {
        text: 2,
        date: 1,
    };

    export default {
        data() {
            return {
                SEARCH_BY_TYPES,
                search_by_options: {
                    name: {
                        value: 'name',
                        text: 'Name',
                        type: SEARCH_BY_TYPES.text
                    },
                    email: {
                        value: 'email',
                        text: 'Email',
                        type: SEARCH_BY_TYPES.text
                    },
                },
                search_by: null,
                search_query: null
            }
        },
        computed: {
            current_search_by_type() {
                let search_by_option = _.find(this.search_by_options, { value: this.search_by });
                if (search_by_option) {
                    return search_by_option.type;
                }
                return null;
            }
        },
        methods: {
            onSearchByChange() {
                this.search_query = null;
            }
        },
        watch: {
            'search_query': _.debounce(function () {
                this.$emit('searchChange', {
                    search_by: this.search_by,
                    search_query: this.search_query
                })
            }, 600)
        }
    }
</script>

<style lang="scss">
    .search-deal-input {
        .app-search {
            input, input:focus {
                margin-right: 10px;
            }
        }

        .search-input, .search-input:focus {
            border-bottom-left-radius: 0 !important;
            border-top-left-radius: 0 !important;
            @media (max-width: 576px) {
                width: 100% !important;
            }
        }

        .search-datepicker, .search-datepicker:hover {
            input {
                border-radius: 0 30px 30px 0;
                border: 1px solid #e9ecef;
                font-size: 13px;
                height: 34px;
                padding-left: 18px;
                padding-right: 40px;
                background: #f8f9fa;
                box-shadow: none;
                width: 200px;
                @media (max-width: 576px) {
                    width: 100%;
                }
            }

            @media (max-width: 576px) {
                width: 100%;
            }

            svg {
                visibility: hidden;
            }
        }
    }

</style>
